import React, { useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import PreviewButton from "../PreviewButton";
import ValidationButton from "../ValidationButton";
import {completeTask, getTask} from "../../../store/action/taskAction";

import { useDispatch, useSelector } from "react-redux";

import {
  createCommunicationChannel,
   getPartyDetails,
    addCommunicationChannelToPerson,
} from "../../../store/action/party";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "relative",
  },
  paper: {
    display: "flex",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  leftSection: {
    flex: 1,
    padding: "20px",
  },
  rightSection: {
    flex: 1,
    padding: "20px",
  },
  inputLabel: {
    color: "rgba(70, 78, 95, 1)",
    fontWeight: 400,
    fontFamily: "Poppins",
    fontSize: 12,
  },
  inputTextArea: {
    width: "100%",
    marginBottom: "20px",
  },
  inputContainer: {
    border: "rgba(243, 246, 249, 1)",
    background: "rgba(243, 246, 249, 1)",
    width: "100%",
    height: "36px",
    borderRadius: 4,
    marginBottom: "20px",
  },
  previewBtn: {
    position: "absolute",
    //background: 'rgb(243, 246, 249)',
    right: "-165px",
  },
  mainContent: {
    width: "95%",
    display: "flex",
    flexDirection: "column",
  },
}));

const CustomerNumTel = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();

  const classes = useStyles();
  const dispatch = useDispatch();

  const [isTaskClaimed, setIsTaskClaimed] = useState(true);
  const [proposedServiceId, setProposedServiceId] = useState(null);
  const [contactClient, setContactClient] = useState("00216");
  const [partyDetails, setPartyDetails] = useState(null);
  const username = localStorage.getItem("username");

  const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
  const [task, setTask] = useState(taskReducer);
  const [ customerPartyUid , setCustomerPartyUid] = useState();
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleClose = () => {
    setOpenErrorDialog(false);
    setErrors([]);
  };

  useEffect(() => {
    const fetchTask = async () => {
      try {
        const response = await getTask(taskId, username);
        console.log("response: " +  response?.businessKey);
        setTask(response)
        setInfoSinistre(response?.businessKey)
        setVariables(response?.variables)
        setCustomerPartyUid(response?.variables?.customerPartyUid?.value)
        const driverDetails = await getPartyDetails(response?.variables?.customerPartyUid?.value);
        setPartyDetails(driverDetails);
      } catch (error) {
        console.error(`Error fetching task details: ${error.message}`);
      }
    };
    fetchTask();
  }, [dispatch, taskId, username]);

  const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
  const [variables, setVariables] = useState(task?.variables)

  const handleContactClientChange = (e) => {
    const input = e.target.value;

    if (input === "") {
      setContactClient("00216");
      return;
    }

    if (input.length < 5) {
      setContactClient("00216");
      return;
    }

    if (!input.startsWith("00216")) {
      return;
    }

    const numbersAfterPrefix = input.substring(5);

    if (/^\d{0,8}$/.test(numbersAfterPrefix)) {
      setContactClient("00216" + numbersAfterPrefix);
    }
  };

  const fullName = partyDetails?.name + " " + partyDetails?.lastName;
    const getAdresse = (partyAddresses) => {
        const address = partyAddresses[0]?.address?.number+" "+ partyAddresses[0]?.address?.street+" "+partyAddresses[0]?.address?.state?.label+" "+partyAddresses[0]?.address?.postalCode?.postalCode
        if(address.includes("undefined")){
          return "N/A"
        }else {
          return address || {}
        }

      }
      const code = partyDetails?.code;
    const address = partyDetails?.partyAddresses[0]?.address?.street;
    const emailClient = partyDetails?.partyCommunicationChannels.find(channel => channel.communicationChannel.type === "EMAIL")?.communicationChannel?.value;


  useEffect(() => {
    if (task && task?.variables && task?.variables?._proposedServiceId) {
      setProposedServiceId(task?.variables?._proposedServiceId.value);
    } else {
      console.log("variables is null");
    }
  },[]);

  const ValidationAction = async () => {
    const validationErrors = [];

    const phoneRegex = /^[0-9]+$/;
    if (!contactClient) {
      validationErrors.push("Le numéro de téléphone est requis");
    } else if (!phoneRegex.test(contactClient)) {
      validationErrors.push("Le numéro de téléphone doit être un numéro tunisien valide (8 chiffres commençant par 2, 4, 5 ou 9)");
    }

    if (!customerPartyUid) {
      validationErrors.push("Impossible d'identifier le client");
    }

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setOpenErrorDialog(true);
      return;
    }

    try {
      console.log("Starting ValidationAction");

      const communicationChannelResponse = await dispatch(
          createCommunicationChannel({
            type: "PHONECONTACT",
            value: contactClient,
          })
      );

      if (!communicationChannelResponse || !communicationChannelResponse._id) {
        console.error("Failed to create communication channel.");
        setErrors(["Échec de la création du canal de communication"]);
        setOpenErrorDialog(true);
        return;
      }

      const communicationChannelId = communicationChannelResponse._id;

      await dispatch(
          addCommunicationChannelToPerson({
            uid: customerPartyUid,
            communicationChannelId: communicationChannelId,
            status: "ACTIVE",
          })
      );

      //let variables = {};
      console.log("variables", variables);
      setVariables(variables.customerContact = {
        value: contactClient,
        type: "String",
      });


      await dispatch(completeTask(taskId, username, variables));

      navigate('/todo-list', { reload: true });
    } catch (error) {
      console.error("Error during ValidationAction:", error);
      setErrors(["Une erreur s'est produite lors de la validation"]);
      setOpenErrorDialog(true);
    }
  };

  useEffect(() => {
    if (task?.assignee === username) {
      setIsTaskClaimed(false);
    } else {
      setIsTaskClaimed(true);
    }
  }, [task]);
  return (
    <div className={classes.root}>
      <div style={{ display: "flex" }}>
        <div className={classes.mainContent}>
          <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>
          <Paper className={classes.paper}>
            <div className={classes.leftSection}>
              <div>
                <label className={classes.inputLabel}>Code</label>
                <input
                  className={classes.inputContainer}
                  type="text"
                  value={code || "N/A"}
                    disabled
                />
              </div>
              <div>
                <label className={classes.inputLabel}>Nom et Prénom</label>
                <input
                  className={classes.inputContainer}
                  type="text"
                  value={fullName || "N/A"}
                    disabled
                 />
              </div>
              <div>
                <label className={classes.inputLabel}>Adresse</label>
                <input
                  className={classes.inputContainer}
                  type="text"
                  value={address || "N/A"}
                    disabled
                 />
              </div>
            </div>
            <div className={classes.rightSection}>
              <div>
                <label className={classes.inputLabel}>Email</label>
                <input
                    className={classes.inputContainer}
                    type="text"
                    value={emailClient || "N/A"}
                    disabled
                />
              </div>

              <div>
                <label className={classes.inputLabel}>Nouveau N° Téléphone Client</label>
                <input
                    className={classes.inputContainer}
                    type="tel"
                    value={contactClient}
                    onChange={handleContactClientChange}
                    disabled={isTaskClaimed}
                    placeholder="00216XXXXXXX"
                    maxLength={13}
                />
              </div>
            </div>
          </Paper>
        </div>
        <PreviewButton claimData={infoSinistre}/>
      </div>
      <ValidationButton taskId={taskId} handleValidation={() => isTaskClaimed ? null : ValidationAction()}/>
      <ErrorsAlert
          open={openErrorDialog}
          errors={errors}
          handleClose={handleClose}
      />
    </div>
  );
};

export default CustomerNumTel;
